import Vue from "vue";
import Vuex from "vuex";
import modules from "./modules/modules";
import createPersistedState from "vuex-persistedstate";
import configAdmin from "@/configs/admin.js";
import getters from "./getters";
Vue.use(Vuex);

export default new Vuex.Store({
  getters,
  state: {},
  mutations: {},
  actions: {},
  modules,
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      key: configAdmin.localstorage_key,
      paths: [
        "userData.selected.category",
        "userData.selected.definision",
        "userData.selected.confirm_edited",
        "userData.selected.template",
        "userData.selected.accept_terms",
        "userData.selected.orders.orderNo",
        "userData.selected.is_print_address",
        "userData.selected.is_bring_in",
        "userData.selected.print_invoice",
        "userData.selected.payment_method",
        "userData.order.orderNo",
        "userData.order.thumbnailBackURL", //a020 preview image
        "userData.order.thumbnailFrontURL",
        "userData.order.ordererInformation",
        "userData.order.isConinueFromTemporary",
        "userData.order.printContens",
        "userData.order.receivers",
        "userData.order.reOrder",
        "userData.order.orderToken",

        //list template select by type
        "userData.templates.listTemplateSelect",
        "userData.templates.templateActive",

        "appData.cdRaws",
      ]
    }),
    createPersistedState({
      key: configAdmin.localstorage_key,
      paths: [
        "userStore.loginId",
        "userStore.sessionId",
        "userStore.userType",
        "shopMode.shopId",
        "shopMode.shopName",
      ]
    })
  ]
});
